import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col, Steps, Timeline, Divider, Image } from "antd";
import Tabs from "../../../components/Tab/Tab";
import "./ProposalHistory.css";
import { useLocation } from "react-router-dom";

const ProposalHistory = () => {


  let tabMenu = []

  const location = useLocation();

  const Data = location?.state?.detail
  const proposalArrObject = Data?.proposalHistory

  //console.log(proposalArrObject, 'proposalArrObject');

  return (
    <>
      <div className="form-container">
        <Tabs 
        Tabs
        tabBarGutter={0}
        tabMenu={tabMenu}
        header="Proposal History"
        activeKey="5"
      />
        {proposalArrObject ? (
          <Row>
            <Col
              xs={22}
              sm={22}
              md={22}
              className="form-body his-container"
              style={{
                margin: "0 auto",
              }}
            >
     <>
       <h2 className="his-title">Proposal Data</h2>
       <Timeline className="p4">
         {/* {proposalArrObject.map((datas) => ( */}
           <Timeline.Item color="red">
             <p className="ml10 timeline-title">{proposalArrObject?.activityDescription}</p>
             <Row className="timeline-desc">
               <Col xs={22} sm={22} md={12} className="ml10 desc">
                 <p>{proposalArrObject?.remarks}</p>
               </Col>
               <Col xs={22} sm={22} md={11} className="time-content">
                 <p>{proposalArrObject?.activityDescription}</p>
                 <p style={{ marginTop: "-12px" }}>{proposalArrObject?.remarks}</p>
               </Col>
             </Row>
           </Timeline.Item>
         {/* ))} */}
       </Timeline>
     </>
            </Col>
          </Row>
        ) : (
          <Row gutter={["", 20]} justify="center">
            <Col className="form-body" xs={22} sm={24} md={16} lg={16} xl={16}>
              <div className="proposal">
                <div className="bg-norecord"></div>
                <p className="norecord-title">No Records Found</p>
              </div>
            </Col>
          </Row>
        )}
      </div>
    </>
  );
};

export default ProposalHistory;
